import React, { memo } from "react";
import { AsFormItemLayout } from "./AsFormItemLayout";
import type { IFormItemLayout, TTaxResidence } from "@adgm/cross-models";
import { KycTaxResidenceTable } from "./KycTaxResidencesTable";
import { KycLabelElement } from "./KycLabelElement";
import { isEqual } from "lodash-es";

interface IProps extends IFormItemLayout<TTaxResidence[]> {
  value?: TTaxResidence[];
  onChange: (value: TTaxResidence[]) => void;
}

/**
 * 自定义比较函数，用于优化memo性能
 * @description 对value数组进行深度比较，其他props使用浅比较
 * @param prevProps - 前一次props
 * @param nextProps - 下一次props
 * @returns boolean - 是否相等
 */
const areEqual = (prevProps: IProps, nextProps: IProps) => {
  return (
    isEqual(prevProps.value, nextProps.value) &&
    prevProps.label === nextProps.label &&
    prevProps.error === nextProps.error &&
    prevProps.sequenceNumber === nextProps.sequenceNumber &&
    prevProps.tip === nextProps.tip &&
    prevProps.hideErrorSpace === nextProps.hideErrorSpace &&
    prevProps.required === nextProps.required &&
    prevProps.style === nextProps.style
  );
};

/**
 * 税务居住地表单组件
 * 用于输入税务居住地信息
 */
export const TaxResidenceForm: React.FC<IProps> = memo(
  ({
    value = [],
    onChange,
    error,
    label,
    tip,
    hideErrorSpace,
    sequenceNumber,
    style,
    required,
  }) => {
    return (
      <AsFormItemLayout
        label={label}
        error={error}
        tip={tip}
        hideErrorSpace={hideErrorSpace}
        required={required}
        labelElement={
          <KycLabelElement
            label={label}
            sequenceNumber={sequenceNumber}
            tip={tip}
            required={required}
          />
        }
        style={style}>
        <KycTaxResidenceTable
          value={value}
          onChange={newValue => {
            onChange?.(newValue);
          }}
        />
      </AsFormItemLayout>
    );
  },
  areEqual,
);
